import React, { Component } from 'react'
import { string, object, bool, shape } from 'prop-types'
import { Panel, PanelList, PanelLineChart, PanelAMToolLineChart, PanelBarChart, PanelAMToolKPIs } from 'components'
import { translate } from 'react-i18next'
import PHASE from 'utils/constants/phases'
import DATA_SELECTORS from 'data/selectors'
import { find } from 'lodash'
import './SectionPanels.css'


@translate()
export class SectionPreSeasonPanels extends Component {
    static propTypes = {
        data: object.isRequired,
        selectedGroupId: string,
        selection: object.isRequired,
        curvesParams: shape({
            engine: object.isRequired,
            gearbox: object.isRequired,
            wheels: object.isRequired
        }),
        isAMToolAvailable: bool.isRequired,
        isAMToolActive: bool.isRequired
    }

    state = {
        showAMToolInfo: false
    }

    componentWillMount() {
        const { isAMToolActive } = this.props
        if (isAMToolActive) this.setState({ showAMToolInfo: true })
        this.selectors = DATA_SELECTORS[PHASE.PRE_SEASON]
        this.refreshGroupData(this.props)
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.selectedGroupId !== this.props.selectedGroupId) {
            this.refreshGroupData(nextProps)
        }
        if (nextProps.isAMToolActive !== this.props.isAMToolActive) {
            this.setState({ showAMToolInfo: nextProps.isAMToolActive })
        }
    }
    handleToggleShowAMToolInfo = () => this.setState({ showAMToolInfo: this.props.isAMToolActive && !this.state.showAMToolInfo })

    refreshGroupData = props => {
        const { data, selectedGroupId, selection, curvesParams, t } = props
        this.hide = !selectedGroupId
        if (selectedGroupId) {
            const selector = find(this.selectors, item => item.id === selectedGroupId)
            this.typeSelected = selector.type
            const groupData = data[selectedGroupId]
            this.listTitle = t('game.PRE_SEASON.panelDetailsTitle', { name: selector.name })
            this.list = groupData.details
            this.performanceMax = groupData.options.map(option => ({ label: option.shortname, value: option.performanceMax }))
            this.expectedAssetLife = groupData.options.map(option => ({ label: option.shortname, value: option.expectedAssetLife }))
        } else {
            this.listTitle = null
            this.list = null
            this.performanceMax = null
            this.expectedAssetLife = null
        }
    }

    render() {
        const { data, selectedGroupId, selection, curvesParams, isAMToolAvailable, isAMToolActive, t } = this.props
        const { showAMToolInfo } = this.state
        return (
            <section className={['Panels', { Hide: this.hide }]} onClick={this.handleToggleShowAMToolInfo}>
                <div className="h-100 flex row-stretch">
                    <PanelList title={this.listTitle} list={this.list} />
                    <Panel id="tour-step-4" className={['PanelCharts', { clickable: isAMToolActive }]}>
                        <div className={['flex row-stretch-center', { Hide: this.hide || showAMToolInfo }]}>
                            <PanelLineChart
                                className=""
                                curvesParams={curvesParams}
                                typeSelected={this.typeSelected}
                            />
                            {this.performanceMax && (
                                <PanelBarChart
                                    title={t('game.PRE_SEASON.panelPerformanceMax')}
                                    values={this.performanceMax}
                                />
                            )}
                            {this.expectedAssetLife && (
                                <PanelBarChart
                                    title={t('game.PRE_SEASON.panelExpectedAssetLife')}
                                    values={this.expectedAssetLife}
                                />
                            )}
                        </div>
                        {isAMToolAvailable && (
                            <div className={['flex row-stretch-center', { Hide: this.hide || !showAMToolInfo }]}>
                                <PanelAMToolLineChart
                                    className=""
                                    data={data}
                                    selectedGroupId={selectedGroupId}
                                    selection={selection}
                                    curvesParams={curvesParams}
                                    typeSelected={this.typeSelected}
                                />
                                <PanelAMToolKPIs
                                    data={data}
                                    selectedGroupId={selectedGroupId}
                                    selection={selection}
                                />
                            </div>
                        )}
                    </Panel>
                </div>
            </section>
        )
    }
}



// WEBPACK FOOTER //
// src/components/Sections/Panels/SectionPreSeasonPanels.js